import { GAME_LOADING, GAME_SET } from "../myResultsActions";
import { GAMES_UPDATE } from "../../LastUpdated/lastUpdatedActions";

export const gamesReducer = (
  state = {
    current: null,
    loading: false,
    initLoading: true,
    updated: [],
    links: null,
    hasOpenSubLeagues: false,
    hasSubLeagues: false,
  },
  action
) => {
  switch (action.type) {
    case GAME_LOADING:
      return { ...state, loading: true };
    case GAME_SET:
      return {
        ...state,
        current: action.payload.game,
        links: action.payload.links,
        strings: action.payload.strings,
        initLoading: false,
        updated: state.updated.filter(
          (gameId) => action.payload.game.id != gameId
        ),
        meta: action.payload.meta,
        loading: false,
        hasOpenSubLeagues: action.payload.hasOpenSubLeagues,
        hasSubLeagues: action.payload.hasSubLeagues,
      };
    case GAMES_UPDATE:
      return {
        ...state,
        updated: state.updated.concat(action.payload.games.map((g) => g.id)),
      };
    default:
      return state;
  }
};
